export enum PatientMedicalHistoryConstants {
  SAVE_MEDICAL_HISTORY = 'patientMedicalHistory/SAVE_MEDICAL_HISTORY',
  SET_RESPONSE = 'patientMedicalHistory/SET_RESPONSE',
  SET_PATIENT_MEDICAL_HISTORY = 'patientMedicalHistory/SET_PATIENT_MEDICAL_HISTORY',
  SET_SELECTED_MEDICAL_HISTORY_PNNV = 'patientMedicalHistory/SET_SELECTED_MEDICAL_HISTORY_PNNV',
  RESET_STATE = 'patientMedicalHistory/RESET_STATE',
  SET_NO_KNOWN_HISTORY = 'patientMedicalHistory/SET_NO_KNOWN_HISTORY',
  SET_IS_LOADING = 'patientMedicalHistory/SET_IS_LOADING',
  SET_SELECTED_MEDICAL_HISTORY = 'patientMedicalHistory/SET_SELECTED_MEDICAL_HISTORY',
  SET_SELECTED_MEDICAL_HISTORY_ICD_NEMSIS_BASIC = 'patientMedicalHistory/SET_SELECTED_MEDICAL_HISTORY_ICD_NEMSIS_BASIC',
  SET_OBTAINED_FROM = 'patientMedicalHistory/SET_OBTAINED_FROM',
  SET_EMERGENCY_INFO_FORM = 'patientMedicalHistory/SET_EMERGENCY_INFO_FORM',
  SAVE_PATIENT_MEDICAL_HISTORY = 'patientMedicalHistory/SAVE_PATIENT_MEDICAL_HISTORY',
}
